import { useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { UserSwitch } from "@phosphor-icons/react";

const DEMO = [
  { key: "guest", label: "Guest", action: "logout" },
  { key: "ben", label: "Ben (Member)", email: "ben@kutz.demo", password: "BenDemo1!" },
  { key: "steve", label: "Steve (Professional)", email: "steve@kutz.demo", password: "ProDemo1!" },
  { key: "hq", label: "HQ (Owner)", email: "lachlan.penleysmith@gmail.com", password: "KutzFounder2026!" },
];

export default function DemoSwitcher() {
  const [open, setOpen] = useState(false);
  const { logout, refresh } = useAuth();

  const switchTo = async (d) => {
    try {
      if (d.action === "logout") { await logout(); toast.success("Guest mode."); }
      else {
        await api.post("/auth/login", { email: d.email, password: d.password });
        await refresh();
        toast.success(`Signed in as ${d.label}.`);
      }
      setOpen(false);
    } catch (e) {
      toast.error("Switch failed.");
    }
  };

  return (
    <div className="fixed bottom-24 right-4 md:bottom-6 md:right-6 z-[60]" data-testid="demo-switcher">
      {open && (
        <div className="mb-3 border border-cream/15 bg-ink/95 backdrop-blur p-3 w-56 rounded-sm shadow-2xl">
          <p className="overline mb-2">Dev · Demo role</p>
          <div className="space-y-1">
            {DEMO.map((d) => (
              <button
                key={d.key} onClick={() => switchTo(d)}
                data-testid={`demo-${d.key}`}
                className="w-full text-left px-3 py-2 text-xs uppercase tracking-[0.18em] text-cream/80 hover:bg-cream/5 hover:text-gold rounded-sm"
              >
                {d.label}
              </button>
            ))}
          </div>
        </div>
      )}
      <button
        onClick={() => setOpen(!open)}
        data-testid="demo-toggle"
        className="w-12 h-12 rounded-full bg-gold text-ink flex items-center justify-center shadow-2xl hover:brightness-110 transition"
        aria-label="Demo role switcher"
      >
        <UserSwitch size={22} weight="bold" />
      </button>
    </div>
  );
}
